<template>
  <el-dialog
    title="订单操作记录"
    :visible.sync="visibleDialog"
    width="520px"
    top="calc(50vh - 220px)"
    class="pop-dialog pop-order-record"
    append-to-body>
    <div class="record-con" v-loading="loading">
      <el-table
        :data="tableData">
        <el-table-column
          prop="time"
          label="日期"
          width="168">
          <template slot-scope="scope">
            <span class="time">
              {{ scope.row.operationTime }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="operatorName"
          label="操作人"
          width="140">
        </el-table-column>
        <el-table-column
          prop="operationContent"
          label="操作结果">
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="fetchData"
        :current-page.sync ="page"
        :page-size="10"
        layout="total,prev, pager, next, jumper"
        :total="total">
      </el-pagination>
  </div>
</el-dialog>
</template>
<script>
  export default {
    name:'popOrderRecord',
    data () {
      return {
        visibleDialog:false,
        tableData:[],
        id:'',
        loading:false,
        total:0,
        page:1
      }
    },
    
    methods: {
       // 批量设置不需要回显
      show(item) {
        this.id = item.id
        this.page = 1
        this.total = 0
        this.tableData = []
        console.log('show:',item)
        this.fetchData(this.id)
        this.visibleDialog = true
      },
      fetchData() {
        this.loading = true
        const postData = {
          orderId: this.id,
          pageNo: this.page,
          pageSize: 10
        }
        this.$api.omsOrderOperationLog(postData).then((res) => { 
          if (res.code === 0) { 
            this.tableData = res.data.list
            this.total = res.data.totalNum
          }
        }).finally(() => {
          this.loading = false
        })
      },
    },
  }
</script>
<style lang='scss'>
.pop-order-record{
  .record-con{
    padding: 10px 0 0 0;
    .el-table th.el-table__cell{
      padding: 0;
      height: 28px;
      line-height: 28px;
      font-weight: normal;
      background-color: #F8F8F8;
      .cell{
        font-size: 12px;
        font-weight: normal;
        padding-left: 12px;
        color: #7F7F7F;
      }
    }
    .el-table td.el-table__cell{
      padding: 0;
      padding: 6px 0 8px;
      .cell{
        font-size: 12px;
        padding-left: 12px;
        line-height: 18px;
      }
      .time{
        font-size: 12px;
        color: #7F7F7F;
      }
    }
  }
  .el-pagination{
    text-align: right;
    padding: 20px 0;
  }
}
</style>